import { useEffect, useState } from 'react';

/**
 * Маршрутизаторът е двадесет реда върху `location.hash`. Приложението има
 * десет екрана и нито един от тях не се отваря с адрес отвън, така че
 * цяла библиотека тук би тежала повече, отколкото помага.
 */

function currentPath(): string {
  const hash = window.location.hash.replace(/^#/, '');
  return hash.length > 0 ? hash : '/';
}

export function navigate(to: string, replace = false): void {
  const target = `#${to.startsWith('/') ? to : `/${to}`}`;
  if (replace) window.location.replace(target);
  else window.location.hash = target;
}

export function goBack(): void {
  if (window.history.length > 1) window.history.back();
  else navigate('/', true);
}

export function useRoute(): { path: string; segments: string[] } {
  const [path, setPath] = useState(currentPath);

  useEffect(() => {
    const onChange = () => {
      setPath(currentPath());
      window.scrollTo({ top: 0 });
    };
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  return { path, segments: path.split('/').filter(Boolean) };
}
